import { render, staticRenderFns } from "./ParamTipoMedida.vue?vue&type=template&id=b18741a0"
import script from "./ParamTipoMedida.vue?vue&type=script&lang=js"
export * from "./ParamTipoMedida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports